(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-slider"] && !Shopify.designMode) return;
  try {
    
/* Same slider logic as before */
(function () {
  function initBeforeAfter(sectionRoot) {
    if (!sectionRoot) return;

    const wrapper = sectionRoot.querySelector('.ba-wrapper');
    const beforeLayer = sectionRoot.querySelector('.ba-before-layer');
    const line = sectionRoot.querySelector('.ba-line');
    const handle = sectionRoot.querySelector('.ba-handle');

    if (!wrapper || !beforeLayer || !line || !handle) return;

    let dragging = false;

    const setPosition = (clientX) => {
      const rect = wrapper.getBoundingClientRect();
      let x = clientX - rect.left;
      x = Math.max(0, Math.min(rect.width, x));
      const percent = (x / rect.width) * 100;

      beforeLayer.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      beforeLayer.style.webkitClipPath = `inset(0 ${100 - percent}% 0 0)`;

      line.style.left = `${percent}%`;
      handle.style.left = `${percent}%`;
    };

    handle.addEventListener('mousedown', (e) => { dragging = true; e.preventDefault(); });
    wrapper.addEventListener('mousedown', (e) => { dragging = true; setPosition(e.clientX); });

    handle.addEventListener('touchstart', (e) => { dragging = true; e.preventDefault(); });
    wrapper.addEventListener('touchstart', (e) => { dragging = true; setPosition(e.touches[0].clientX); });

    window.addEventListener('mouseup', () => { dragging = false; });
    window.addEventListener('touchend', () => { dragging = false; });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      setPosition(e.clientX);
    });

    window.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      setPosition(e.touches[0].clientX);
    });

    // initial 50% position
    const rect = wrapper.getBoundingClientRect();
    setPosition(rect.left + rect.width / 2);
  }

  function initAll() {
    document.querySelectorAll('.before-after-section').forEach((section) => initBeforeAfter(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target;
    if (el && el.matches && el.matches('.before-after-section')) initBeforeAfter(el);
    else initAll();
  });

  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target;
    if (el && el.matches && el.matches('.before-after-section')) initBeforeAfter(el);
  });

  document.addEventListener('section:load', (e) => {
    const el = e.target;
    if (el && el.classList && el.classList.contains('before-after-section')) initBeforeAfter(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-logo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // nothing special; theme carousel handles initialization via data attributes
  });

  } catch(e) { console.error(e); }
})();
})();
